import { WjFlexGrid } from '@mescius/wijmo.angular2.grid';
import { ListBox } from '@mescius/wijmo.input';
import { CellType } from '@mescius/wijmo.grid';
import { hidePopup, PopupPosition, showPopup } from '@mescius/wijmo';

export class ColumnPicker {

    static createColumnPicker(host: HTMLElement, grid: WjFlexGrid) {
        const colPickerContainer = document.createElement('div');
        colPickerContainer.classList.add('column-picker');
        colPickerContainer.style.display = 'none';
        colPickerContainer.style.minWidth = '200px';

        const columnPicker = new ListBox(colPickerContainer);
        columnPicker.itemsSource = grid.columns;
        columnPicker.checkedMemberPath = 'visible';
        columnPicker.displayMemberPath = 'header';
        columnPicker.lostFocus.addHandler(() => hidePopup(columnPicker.hostElement));

        host.appendChild(colPickerContainer);

        grid.hostElement.addEventListener('contextmenu', e => {
            e.preventDefault();
            const ht = grid.hitTest(e.pageX, e.pageY);
            if (ht.cellType === CellType.ColumnHeader) {
                showPopup(columnPicker.hostElement, e.target, PopupPosition.BelowRight, true);
            }
        });

        host.addEventListener('click', e => {
            hidePopup(columnPicker.hostElement);
        });
    }
}
